/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./tests-chart.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./tests-chart.component";
var styles_TestsChartComponent = [i0.styles];
var RenderType_TestsChartComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_TestsChartComponent, data: {} });
export { RenderType_TestsChartComponent as RenderType_TestsChartComponent };
export function View_TestsChartComponent_0(_l) { return i1.ɵvid(2, [i1.ɵqud(402653184, 1, { chartElement: 0 }), (_l()(), i1.ɵeld(1, 0, [[1, 0], ["chart", 1]], null, 0, "div", [], null, null, null, null, null))], null, null); }
export function View_TestsChartComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-tests-chart", [], null, null, null, View_TestsChartComponent_0, RenderType_TestsChartComponent)), i1.ɵdid(1, 573440, null, 0, i2.TestsChartComponent, [], null, null)], null, null); }
var TestsChartComponentNgFactory = i1.ɵccf("app-tests-chart", i2.TestsChartComponent, View_TestsChartComponent_Host_0, { testsStatus: "testsStatus", smoothCorners: "smoothCorners", height: "height", width: "width" }, {}, []);
export { TestsChartComponentNgFactory as TestsChartComponentNgFactory };
